export var wrapper = 'flex flex-row mt-4';
export var iconWrapper = 'rounded-full p-2';
//# sourceMappingURL=icon-title-description-tile.styles.js.map